export const colors = [
  {
    value: 'bright',
    text: 'Светлый',
  },
  {
    value: 'dark',
    text: 'Темный',
  },
  {
    value: 'ginger',
    text: 'Рыжий',
  },
  {
    value: 'multi_color',
    text: 'Мульти',
  },
];
